'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Modal } from '@/components/Modal';
import { ZoomableImage, type ZoomableImageProps } from '@/components/Zoomable/ZoomableImage';
import { CmsImage } from './CmsImage';
export interface ZoomableImageModalProps extends ZoomableImageProps {
  openInModal?: boolean;
}
export function ZoomableImageModal(t0) {
  const $ = _c(5);
  const {
    image,
    openInModal: t1,
    zoomable
  } = t0;
  const openInModal = t1 === undefined ? false : t1;
  const [open, setOpen] = useState(false);
  if (!image) {
    return null;
  }
  let t2;
  if ($[0] !== image || $[1] !== open || $[2] !== openInModal || $[3] !== zoomable) {
    t2 = openInModal ? <><button className="cursor-zoom-in" onClick={() => setOpen(true)}><CmsImage {...image} /></button><Modal className="[&_.modal-box]:p-0 [&_.modal-box]:h-[calc(100dvh-1rem)] [&_.modal-box]:w-[calc(100%-1rem)] [&_.modal-box]:bg-black [&_.modal-box]:rounded-md [&_.modal-box]:overflow-hidden" open={open} onClose={() => setOpen(false)} showClose={true} data-testid="fleet-category-image-gallery-modal"><ZoomableImage image={{
          ...image,
          sizes: `${image.width}px`,
          className: "!max-w-none"
        }} zoomable={zoomable} /></Modal></> : <CmsImage {...image} />;
    $[0] = image;
    $[1] = open;
    $[2] = openInModal;
    $[3] = zoomable;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}